var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ../~/_lodash@4.17.15@lodash/_Symbol.js
// module id = 430
// module chunks = 0